import React from 'react';
import ListAccordion from './ListAccordion';
import * as S from './styled';

export default function Consult({ typeMeasureMenu = '', listDataUsers }) {
	return (
		<S.containerInsideAccordion>
			<ListAccordion typeData={typeMeasureMenu} listDataUsers={listDataUsers} />
		</S.containerInsideAccordion>
	);
}
